import { useState } from 'react';
import FaqItem from './FaqItem';
import '../styles/FaqSection.css';

const FAQS = [
  {
    question: '1. WHAT DOES THE BOT ACTUALLY DO?',
    answer:
      'It reads TradingView, financial news, X and TikTok at the same time, looking for stock narratives picking up speed. When one shows up across enough sources with enough momentum, it scores it, and if the score clears the threshold it launches a token on Solana about that narrative. No one presses a button.',
  },
  {
    question: '2. IS IT TRADING STOCKS?',
    answer:
      "No. Botzo doesn't buy or sell equities and doesn't touch your brokerage. He watches what's happening around stocks and turns the strongest narratives into Solana markets.",
  },
  {
    question: '3. WHAT MAKES A NARRATIVE GOOD ENOUGH TO LAUNCH?',
    answer:
      "Confirmation across sources, speed of spread, and whether the price and volume agree with the story. One loud post isn't enough. The same story landing in four places at once is the signal.",
  },
  {
    question: '4. CAN I SEE WHY IT LAUNCHED SOMETHING?',
    answer:
      'Every launch carries its reasoning: the articles, posts and charts that triggered it, plus the score. The rejections are published too, so you can see what it turned down and by how much it missed.',
  },
  {
    question: '5. WHAT IF IT LAUNCHES SOMETHING BAD?',
    answer:
      'It will. A detector that never misses is a detector that never fires. The record is public either way, which is the point of publishing the passes alongside the launches.',
  },
  {
    question: '6. CAN I SUGGEST A NARRATIVE?',
    answer:
      "Not to the bot. It scores what it finds on its own. The watchlist is public though, so you can see what's climbing before it clears, and the Telegram is where people argue about what should.",
  },
];

/**
 * Sits after <TheSteps /> in App.jsx. Uses "section-cover" like the
 * other content sections — see ScrollSections.css.
 */
export default function FaqSection({ zIndex = 5 }) {
  const [openIndex, setOpenIndex] = useState(-1); // none open by default, matching the reference

  return (
    <section id="faqs" className="faq-section section-cover" style={{ zIndex }}>
      <p className="faq-section__eyebrow">( FAQ )</p>
      <h2 className="faq-section__title">Frequently Asked Questions</h2>

      <div className="faq-section__list">
        {FAQS.map((faq, index) => (
          <FaqItem
            key={faq.question}
            question={faq.question}
            answer={faq.answer}
            isOpen={openIndex === index}
            onToggle={() => setOpenIndex(openIndex === index ? -1 : index)}
          />
        ))}
      </div>
    </section>
  );
}